import React from "react";
import { SubjectComponent } from "../../Components/Subjects";
import Wrapper from "../../Components/Wrapper/wrapper";

export const Subjects = () => {
  return (
    <Wrapper header={"Subject"}>
      <SubjectComponent />
    </Wrapper>
  );
};
